import React from "react";

const P = { fill: "currentColor" };
const paths = {
  circle: <circle cx="50" cy="50" r="42" {...P} />,
  square: <rect x="10" y="10" width="80" height="80" rx="10" {...P} />,
  triangle: <path d="M50 8 L92 88 L8 88 Z" {...P} />,
  rectangle: <rect x="5" y="25" width="90" height="50" rx="8" {...P} />,
  star: <path d="M50 5 L61 36 L94 38 L68 58 L77 92 L50 73 L23 92 L32 58 L6 38 L39 36 Z" {...P} />,
  heart: <path d="M50 88 C20 65 5 48 5 32 C5 18 16 8 28 8 C38 8 46 14 50 22 C54 14 62 8 72 8 C84 8 95 18 95 32 C95 48 80 65 50 88 Z" {...P} />,
  oval: <ellipse cx="50" cy="50" rx="45" ry="30" {...P} />,
  diamond: <path d="M50 5 L92 50 L50 95 L8 50 Z" {...P} />,
  pentagon: <path d="M50 6 L94 38 L77 92 L23 92 L6 38 Z" {...P} />,
  hexagon: <path d="M28 10 L72 10 L94 50 L72 90 L28 90 L6 50 Z" {...P} />,
  octagon: <path d="M32 6 L68 6 L94 32 L94 68 L68 94 L32 94 L6 68 L6 32 Z" {...P} />,
  crescent: <path d="M62 8 A44 44 0 1 0 62 92 A34 34 0 1 1 62 8 Z" {...P} />,
  semicircle: <path d="M6 70 A44 44 0 0 1 94 70 Z" {...P} />,
  cross: <path d="M36 6 H64 V36 H94 V64 H64 V94 H36 V64 H6 V36 H36 Z" {...P} />,
  arrow: <path d="M6 38 H56 V14 L94 50 L56 86 V62 H6 Z" {...P} />,
};

export const SHAPE_KEYS = Object.keys(paths);

export function ShapeSvg({ shape, size = 96, color = "#8B5CF6", className = "" }) {
  return (
    <svg viewBox="0 0 100 100" width={size} height={size} className={className} style={{ color, filter: "drop-shadow(0 6px 6px rgba(0,0,0,0.15))" }} aria-label={shape}>
      {paths[shape] || paths.circle}
    </svg>
  );
}
